import React, { useEffect, useState } from "react";
import moment from "moment";
import { FormatNumber2 } from "../../utility/functions/formatNumber";
const Comp = ({ TotalFilterData, finalFilterData, prepareRow, e, i }) => {
  const [TOTALROW, setTotalRow] = useState([]);
  const [finalData, setFinalData] = useState([]);
  useEffect(() => {
    const f = TotalFilterData.filter(
      (r) =>
        r.values.ITEMNAME !== "Total..." &&
        r.values.SECTION_NAME === e.SECTION_NAME
    );
    setTotalRow(
      TotalFilterData.filter((r) => r.values.ITEMNAME === "Total...")
    );
    const data = f[0]
      ? [
          {
            ...f[0],
            values: {
              ...f[0].values,
              filterName: e.SECTION_NAME,
            },
          },
          ...f,
          {
            ...f[0],
            values: {
              ...f[0].values,

              CUSTOMER_NAME: "",
              CUSTOMER_MOBILE: "",
              DATE: "",
              SALE_PRICE: "",
              TAX1_RATE: "",
              TAX1_AMT: "",
              TAX2_AMT: "",
              TAX3_AMT: "",
              TAX2_RATE: "",
              TAX3_RATE: "",
              QNTY: (
                <div className="font-semibold text-[11px] text-right">
                  {" "}
                  {f.reduce((acc, row) => acc + Number(row.values.QNTY), 0)}
                </div>
              ),
              RATE: "",
              AMOUNT: (
                <div className="font-semibold text-[11px] text-right">
                  {" "}
                  {FormatNumber2(
                    f.reduce((acc, row) => acc + Number(row.values.AMOUNT), 0)
                  )}
                </div>
              ),
              GTOTAL: (
                <div className="font-semibold text-[11px] text-right">
                  {" "}
                  {FormatNumber2(
                    f.reduce((acc, row) => acc + Number(row.values.GTOTAL), 0)
                  )}
                </div>
              ),
              ICODE: "",
              ITEMNAME: (
                <div className="font-semibold text-[11px] text-right">
                  {" "}
                  Sub Total...
                </div>
              ),
              DATE: "",
              SECTION_NAME: "",
              SUBTOTAL: true,
            },
          },
        ]
      : [];
    const uniqueData = data;
    //     const uniqueData = data.filter(
    //     (item, index, self) => index === self.findIndex((i) => i.id === item.id)
    //   );
    setFinalData(
      i === finalFilterData.length - 1
        ? [
            ...uniqueData,
            {
              ...TOTALROW[0],
              values: {
                ...TOTALROW[0]?.values,
                ITEMNAME: (
                  <div className="font-semibold text-[11px] text-right">
                    {" "}
                    Total...
                  </div>
                ),
                PRINTTOTAL: true,
              },
            },
          ]
        : uniqueData
    );
  }, [TotalFilterData, finalFilterData]);
  return finalData.map((row, i) => {
    prepareRow(row);
    return (
      <tr key={i} {...row.getRowProps()}>
        {row.values.filterName
          ? row.cells
              .filter((e, i) => {
                return i === 0;
              })
              .map((cell, ci) => (
                <td
                  {...cell.getCellProps()}
                  style={{
                    padding: "8px",
                    fontSize: "11px",
                  }}
                  colSpan={3}
                  key={ci}
                >
                  <div className="font-semibold text-[14px]">
                    {ci === 0 && row.values.filterName}
                  </div>
                </td>
              ))
          : row.values.SUBTOTAL
          ? row.cells.map((cell, ci) => (
              <td
                {...cell.getCellProps()}
                style={{
                  padding: "8px",
                  borderRight: "1px solid black",
                  borderTop: "1px solid black",
                  borderBottom: "1px solid black",
                  fontSize: "11px",
                }}
                key={ci}
              >
                <div
                  style={{
                    textAlign: cell.render("Cell").props.cell.column.align
                      ? cell.render("Cell").props.cell.column.align
                      : "left",
                  }}
                  className="whitespace-normal"
                >
                  {cell.render("Cell").props.cell.column.type === "date"
                    ? cell.render("Cell").props.cell.value
                      ? moment(cell.render("Cell").props.cell.value).format(
                          "YYYY-MM-DD"
                        )
                      : ""
                    : cell.render("Cell").props.cell.value === "0.00"
                    ? null
                    : cell.render("Cell")}
                </div>
              </td>
            ))
          : row.cells.map((cell, ci) => (
              <td
                {...cell.getCellProps()}
                style={{
                  padding: "8px",

                  borderRight: row.values.PRINTTOTAL
                    ? "1px solid black"
                    : "1px dashed black",
                  borderTop: row.values.PRINTTOTAL
                    ? "1px solid black"
                    : "1px dashed black",
                  fontSize: "11px",
                  width: cell?.column?.width,
                }}
                className="overflow-hidden "
                key={ci}
              >
                <div
                  style={{
                    textAlign: cell.render("Cell").props.cell.column.align
                      ? cell.render("Cell").props.cell.column.align
                      : "left",
                    width: cell?.column?.width,
                  }}
                  className=" "
                >
                  {cell.render("Cell").props.cell.column.type === "date"
                    ? moment(cell.render("Cell").props.cell.value).format(
                        "YYYY-MM-DD"
                      )
                    : cell.render("Cell").props.cell.value === "0.00"
                    ? null
                    : cell.render("Cell")}
                </div>
              </td>
            ))}
      </tr>
    );
  });
};

const Printcomp = ({ finalFilterData, TotalFilterData, prepareRow }) => {
  return finalFilterData.map((e, i) => {
    return (
      <Comp
        key={i}
        finalFilterData={finalFilterData}
        TotalFilterData={TotalFilterData}
        prepareRow={prepareRow}
        e={e}
        i={i}
      />
    );
  });
};

export default Printcomp;
